import { Controller } from '@hotwired/stimulus'
import { get } from '../lib/request'

export default class extends Controller {
  static values = { errorUrl: String }

  connect = () => {
    this.checkForBlocker()
  }

  async checkForBlocker() {
    const iframes = document.querySelectorAll('iframe')

    iframes.forEach((iframe) => {
      fetch(iframe.src)
        .catch(() => {
          get(this.errorUrlValue, { responseKind: 'turbo-stream' })
        })
    })
  }
}
